import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button,Table } from "react-bootstrap";
import Card from "../../../components/Card";
import { toast } from 'react-toastify';
import { API_TTS_PLANS_LIST, API_ACL_SETTING_LIST, API_USERS_PROFILE, API_COMPANY_LIST, API_CALL_CENTRE_LIST, API_PARENT_ACL_SETTINGS } from "../../../service/url";
import { postApiCall, getApiCall } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import { USER_STATUS } from "../../../utilities/constant";
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import {getUser,
  getUserModules,
  getUserUpdateAccessRoleLabel,
  ifUserAssociateCompany,
} from "../../../utilities/setting";
import { validatePhone } from "../../../utilities/helpers";
import { ROUTES, USERS_ROLE } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { USER_ROLES } from '../../../utilities/constant';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {validateEmail} from '../../../utilities/helpers'
import "../../../assets/custom/css/custom.css";
import Select from 'react-select';



const VALIDATION_MIN_PASSWORD_LENGTH = 6;

const UserAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [aclSettingList, setAClSettingList] = useState([]);
  const [selectedACL, setSelectedACL] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [isCompanyAdmin, setCompanyAdmin] = useState(false);
  const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
  const [isSuperAdminLogged, setIsSuperAdminLogged] = useState(false);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [isResellerLogged, setIsResellerLogged] = useState(false);
  const [isCompanyUserLogged, setIsCompanyUserLogged] = useState(false);
  const [isCallCenterAdminLogged, setIsCallCenterAdminLogged] = useState(false);
  const [isReseller, setIsReseller] = useState(false);
  const [channel, setChannel] = useState(0);
  const [callCenterAdminAgent , setCallCenterAdminAgent] = useState(0);
  const [callCenterAdminTeamlead , setCallCenterAdminTeamlead] = useState(0);
  const [agent , setAgent] = useState(0);
  const [liveAgent , setLiveAgent] = useState(0);
  const [subLicenceId, setSubLicenceId] = useState("");
  const [selectedFlowType, setSelectedFlowType] = useState("");
  const [companyUserRole, setCompanyUserRole] = useState(false);
  const [currentEditUserRole, setCurrentEditUserRole] = useState(null);
  const [availableLicence, setAvailableLicence] = useState({});
  const [expiryDate, setExpiryDate] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [editUserParent, setEditUserParent] = useState(null);
  const [errors, setErrors] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
    });

  const [currentUserLicence, setCurrentUserLicence] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
  });

  const [currentUserTotalLicence, setCurrentUserTotalLicence] = useState({
      role_ccagent: "",
      role_ccteamlead: "",
      agent: "",
      channel: "",
      live_agent: ""
  });

  const usedLicence = {
    role_ccagent: "",
    role_ccteamlead: "",
    agent: "",
    channel: "",
    live_agent: ""
  };

  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [companyList, setCompanyList] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [callCenterList, setCallCenterList] = useState([])
  const [selectedCallCenter, setSelectedCallCenter] = useState("")
  const [tts_plan_id, setTtsPlanId] = useState(null);
  const [showTtsPlanId, setShowTtsPlanId] = useState(false);
  const [ttsPlanList, setTtsPlanList] = useState([]);

  useEffect(() => {
    async function superadminCheck() {
      const rawUser = await AsyncStorage.getItem('user');
      if (!rawUser) {
        console.error("User not found in AsyncStorage");
        return null; // or handle as needed
      }

      let user;
      try {
        user = JSON.parse(rawUser);
        setLoggedInUser(user);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user.role !== USER_ROLES.RESELLER && user.role !== USER_ROLES.SUPERADMIN) {
        // const updatedAvailableLicence = {
        //   role_ccagent: (user?.sub_user_licence?.available_licence?.role_ccagent || 0) + (callCenterAdminAgent || 0),
        //   role_ccteamlead: (user?.sub_user_licence?.available_licence?.role_ccteamlead || 0) + (callCenterAdminTeamlead || 0),
        //   agent: (user?.sub_user_licence?.available_licence?.agent || 0) + (agent || 0),
        //   channel: (user?.sub_user_licence?.available_licence?.channel || 0) + (channel || 0),
        //   live_agent: (user?.sub_user_licence?.available_licence?.live_agent || 0) + (liveAgent || 0),
        // };
        // setAvailableLicence(updatedAvailableLicence);
      }

      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdminLogged(true)
        setSuperAdminData(user);
      }
      if (user.role === USER_ROLES.RESELLER) {
        setIsResellerLogged(true)
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        setIsCompanyUserLogged(true)
      }
      if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterList([{
          id: user?.callcenter?.id,
          name: user?.callcenter?.name
        }])

        setSelectedCallCenter(user?.callcenter?.id)
        setIsCallCenterAdminLogged(true)
      }
      if (selectedUserType === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
      }
      if (selectedUserType === USER_ROLES.COMPANY_ADMIN) {
        setCompanyAdmin(true);
      }
      if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
        setCallCenterAdmin(true);
      }
      if (user.role === USER_ROLES.COMPANY_ADMIN){
        setCompanyUserRole(true);
      }

      if (user.role === USER_ROLES.RESELLER) {
        setIsReseller(true);
      }

      if (user.role === USER_ROLES.COMPANY_ADMIN) {
        // setCompanyList([{
        //   id: user?.company?.id,
        //   name: user?.company?.name
        // }])
        // setSelectedCompany(user?.company?.id)
        setCompanyAdmin(true);
      }
      
      setLoading(false);
    }
    superadminCheck();
  }, [selectedUserType]);

  useEffect(() => {
      if (selectedACL) {
        const selectedAclDetails = aclSettingList?.filter((item) => {
          return item?.id == selectedACL
        });
        if (selectedAclDetails && selectedAclDetails?.length > 0) {
          const modules = getKeysWithTrueValues(JSON.parse(selectedAclDetails?.[0]?.module_operations||'{}'));
          if (modules?.includes("TTS")) {
            setShowTtsPlanId(true);
          } else {
            setShowTtsPlanId(false);
          }
        }
      } else {
        setShowTtsPlanId(false);
      }
    }, [selectedACL]);

  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  useEffect(() => {
    getApiCall(API_TTS_PLANS_LIST).then((resp) => {
      // if (isSuperAdmin && superAdminData) {
      //   const filteredPlans = resp?.filter((item) => {
      //     return item.user_id == superAdminData?.id
      //   });
      //   setTtsPlanList(filteredPlans);
      // } else {
        setTtsPlanList(resp) 
      // }
    }).catch((error) => { toast.error(JSON.stringify(error)) })
  }, [isSuperAdmin, superAdminData]);

  function getProfileApiUrl() {
    return API_USERS_PROFILE.replace(":id", id);
  }

  // Fetch ACLs that are either the parent's own ACL or created by the parent
  useEffect(() => {
    if (!loading) { 
      const url = `${API_PARENT_ACL_SETTINGS}/${id}`;
      getApiCall(url, {})
        .then(onAClSettingListSuccess)
        .catch(onError);
    }
  }, [loading, id]);

  useEffect(() => {
    const profileApiUrl = getProfileApiUrl();
    getApiCall(profileApiUrl, {}).then(onProfileGetSuccess).catch(onError);
  }, [id]);


  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
      if (!loading) { 
        let companiesUrl = null;
        if (isSuperAdminLogged && superAdminData) {
          companiesUrl = `${API_COMPANY_LIST}?queryData=all`;
        } else {
          companiesUrl = API_COMPANY_LIST;
        }
        getApiCall(companiesUrl, {})
          .then(onCompanyListSuccess)
          .catch(onError);
      }
    }, [loading, isSuperAdminLogged, superAdminData, editUserParent]);
  
    function onCompanyListSuccess(resp) {
     setCompanyList(resp)
    //  if (isSuperAdminLogged && superAdminData && (editUserParent?.id == superAdminData?.id)) {
    //   const filteredCompanies = resp.filter((item) => {
    //     return item.created_by == superAdminData?.id
    //   });
    //   setCompanyList(filteredCompanies);
    //   }
    }

     useEffect(() => {
        if (!loading) { 
          getApiCall(API_CALL_CENTRE_LIST, {})
            .then(onCallcenterListSuccess)
            .catch(onError);
        }
      }, [loading]);
    
  function onCallcenterListSuccess(resp) {
    const isSelectedCallCenterAdmin = selectedUserType === USERS_ROLE.CALL_CENTRE_ADMIN;

    if ((!isCallCenterAdmin ) ||
        (isCompanyAdmin && !isSelectedCallCenterAdmin)) {
      setCallCenterList(resp);
    }
  }

  function onProfileGetSuccess(resp) {

    const formattedDate = resp.expiry_date
      ? new Date(resp.expiry_date).toISOString().split("T")[0]
      : "";
    setTtsPlanId(resp.tts_plan_id);
    setEditUserParent(resp.createdByUser);
    setExpiryDate(formattedDate);
    setSubLicenceId(resp.sub_user_licence_id?.id);
    setCurrentEditUserRole(resp?.role);
    setUsername(resp.username);
    setStatus(resp.status);
    setName(resp.name);
    setEmail(resp.email);
    setSelectedACL(resp.acl_settings_id);
    setSelectedUserType(resp.role)
    setSelectedFlowType(resp?.flow_type || null);
    setCallCenterAdminAgent(resp?.sub_user_licence?.available_licence?.role_ccagent);
    setCallCenterAdminTeamlead(resp?.sub_user_licence?.available_licence?.role_ccteamlead);
    setAgent(resp?.sub_user_licence?.available_licence?.agent);
    setChannel(resp?.sub_user_licence?.available_licence?.channel );
    setLiveAgent(resp?.sub_user_licence?.available_licence?.live_agent);
    setCurrentUserLicence({
      role_ccagent: resp?.sub_user_licence?.available_licence?.role_ccagent,
      role_ccteamlead: resp?.sub_user_licence?.available_licence?.role_ccteamlead,
      agent: resp?.sub_user_licence?.available_licence?.agent,
      channel: resp?.sub_user_licence?.available_licence?.channel,
      live_agent: resp?.sub_user_licence?.available_licence?.live_agent
    })
    setCurrentUserTotalLicence({
      role_ccagent: resp?.sub_user_licence?.total_licence?.role_ccagent,
      role_ccteamlead: resp?.sub_user_licence?.total_licence?.role_ccteamlead,
      agent: resp?.sub_user_licence?.total_licence?.agent,
      channel: resp?.sub_user_licence?.total_licence?.channel,
      live_agent: resp?.sub_user_licence?.total_licence?.live_agent
    })

    if (resp.callcenter) {
      setSelectedCallCenter(resp?.callcenter?.id)
    }

    //Set company details
    const companyDetails = resp.company;


    if (companyDetails) {
      setSelectedCompany(companyDetails.id)
    }
    if (resp.assigned_company) {
      setSelectedCompany(resp.assigned_company);
    }
  }

  function onAClSettingListSuccess(resp) {
     setAClSettingList(resp);
  }

  function validateForm() {
    let valid = true;

    if (!username.trim()) {
      valid = false;
      toast.error("Username required");
    } else if (!validateName(name)) {
      valid = false;
      if (!name.trim()) {
        toast.error("Name required");
      } else {
        toast.error(nameError || "Invalid name format");
      }
    } else if (!status || isNaN(status)) {
      valid = false;
      toast.error("Status required");
    } else if (selectedUserType === USER_ROLES.COMPANY_ADMIN || selectedUserType === USER_ROLES.RESELLER) {
      if (selectedCompany === "" || selectedCompany === null || !selectedCompany) {
        valid = false;
        toast.error("Company is required");
      }
    }

    if(!selectedACL && currentEditUserRole !== USER_ROLES.CALL_CENTRE_AGENT) {
      valid = false;
      toast.error("ACL Settings is required");
    }

    if (isSuperAdmin || isCompanyAdmin || isCallCenterAdmin) {
      if (!selectedUserType.trim()) {
        valid = false;
        toast.error("UserType required");
      }
    }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
          if (!selectedCallCenter.trim()) {
            valid = false;
            toast.error("Callcenter required");
          }
        }
    if ((loggedInUser?.id == editUserParent?.id) && !expiryDate) {
      valid = false;
      toast.error("Expiry Date required");
    } else if ((loggedInUser?.id == editUserParent?.id) && expiryDate) {
      // Validate expiry date format and range
      const selectedDate = new Date(expiryDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // Check if date is valid
      if (isNaN(selectedDate.getTime())) {
        valid = false;
        toast.error("Invalid expiry date format. Please select a valid date.");
      } else {
        // Check if date is in the past
        if (selectedDate < today) {
          valid = false;
          toast.error("Expiry Date cannot be in the past. Please select a future date.");
        } else {
          // Check if date is too far in the future (max 100 years from today)
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 100);
          maxDate.setHours(0, 0, 0, 0);
          
          if (selectedDate > maxDate) {
            valid = false;
            toast.error("Expiry Date cannot be more than 100 years in the future. Please select a reasonable date.");
          }
        }
      }
    }
    if (showTtsPlanId) {
      if (!tts_plan_id) {
        valid = false;
        toast.error("TTS Plan is required when selecting ACL having TTS");
      }
    }
    return valid;
  }


  const updateLocalStorage = async (finalData) => {

    try {
        // Save updated user data back to AsyncStorage
        await AsyncStorage.setItem('user', JSON.stringify(finalData));
    } catch (error) {
      console.error('Error updating available licences:', error);
    }
  };

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    if (Object.values(errors).some(value => value !== "")) {
      toast.error("Enter All correct values");
      setButtonDisable(false);
      return;
    }
    const sub_licence = {
      role_ccagent: Number(callCenterAdminAgent) || 0,
      role_ccteamlead: Number(callCenterAdminTeamlead) || 0,
      agent: Number(agent) || 0,
      channel: Number(channel) || 0,
      live_agent: Number(liveAgent) || 0
    };


    const params = { username, name, email, status,
      acl_settings: (selectedACL === "") ? null: selectedACL,
    };

    if (showTtsPlanId) {
      params.tts_plan_id = tts_plan_id;
    }

    if (!isCallCenterAdmin) {
      params.company = selectedCompany !== "" ? selectedCompany : null;
    }

    params.role = selectedUserType

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
          params.callcenterId = selectedCallCenter
        }

    if (selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) {
      params.flow_type = Number(selectedFlowType)
    }

    let finalData


    // if (!isResellerLogged && !isSuperAdminLogged) {
    //   const { user, newAvailableLicences } = await updateAvailableLicences(sub_licence);
    //   finalData = user;
    //   params.parent_licence = newAvailableLicences;
    // }
    
    // if (!isSuperAdminLogged) {
    //   params.sub_licence = sub_licence
    // }
    if (loggedInUser?.id == editUserParent?.id) {
      params.expiry_date = expiryDate;
    }
    try {
      const profileApiUrl = getProfileApiUrl();
      const resp = await postApiCall(profileApiUrl, params);
    
      if (resp) {
        await onUserUpdateSuccess(resp, finalData);
      } else {
        throw new Error(resp?.message || "User Updation failed");
      }
    } catch (error) {
      onError(error);
    }
  }

   async function onUserUpdateSuccess(resp, finalData) {
      if (!isResellerLogged && !isSuperAdminLogged) {
        // await updateLocalStorage(finalData);
      }
      toast.success("User updated successfully");
      setTimeout(() => {
        navigate(`/${ROUTES.USERS.LIST}`);
      }, 1500);
    }

    function onError(err) {
      setButtonDisable(false);
    
      let message = "An unknown error occurred.";
    
      if (err?.response?.data?.message) {
        message = err.response.data.message;
      } else if (err?.message) {
        message = err.message;
      } else if (typeof err === 'string') {
        message = err;
      }
    
      if (message.includes('TokenExpiredError')) {
        errorCheck(err, navigate, setToastProps, setShowToast);
        return;
      }
    
      toast.error(message);
    }
    

  function RenderUserStatusOptions() {
    let arrStatusOptions = [<option key="select-status" value="">Select status</option>];

    USER_STATUS.map((val,idx) => {
      arrStatusOptions.push(<option key={idx} value={val.value}>{val.label}</option>);
    });

    return arrStatusOptions;
  }
 
 const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);
  setEmailError(validateEmail(value));
};

 const validateName = (value) => {
   const trimmedValue = value.trim();
   if (!trimmedValue) {
     setNameError("Name is required");
     return false;
   }
   if (trimmedValue.length < 2 || trimmedValue.length > 100) {
     setNameError("Name must be between 2 and 100 characters");
     return false;
   }
   if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
     setNameError("Name can only contain letters, numbers, and underscores");
     return false;
   }
   setNameError("");
   return true;
 };

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">User Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="username">User Name:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          id="username"
                          placeholder="User Name"
                          readOnly
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        />
                      </Form.Group>


                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="name">Full Name:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          id="name"
                          maxLength={100}
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            validateName(e.target.value);
                          }}
                          onBlur={(e) => validateName(e.target.value)}
                          className={nameError ? "is-invalid" : ""}
                          required
                        />
                        {nameError && <div className="invalid-feedback">{nameError}</div>}
                      </Form.Group>
                    </div>
                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="email">Email:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <Form.Control
                          type="email"
                          id="email"
                          maxLength={100}
                          value={email}
                          onChange={handleEmailChange}
                          required
                        />
                        {emailError && <span className="text-danger">{emailError}</span>}
                      </Form.Group>
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="status">Status:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                        <select
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          className="form-select p-2"
                          id="status"
                        >
                          <RenderUserStatusOptions />
                        </select>
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="pass">Password:</Form.Label>
                        <Form.Control
                          type="password"
                          id="pass"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Form.Group> */}
                      {/* <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="rpass">
                          Confirm Password:
                        </Form.Label>
                        <Form.Control
                          type="password"
                          id="rpass"
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </Form.Group> */}
                       <Form.Group className="col-md-6 form-group">
                       <Form.Label htmlFor="aclSetting">ACL Setting:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                          <Form.Select
                            id="aclSetting"
                            required
                            value={selectedACL}
                            className="p-2"
                            onChange={(e) => setSelectedACL(e.target.value)}
                          >
                            <option value={""}>ACL Setting</option>
                            {aclSettingList.map(function (val, idx) {
                              return (
                                <option key={idx} value={val.id || val.id}>
                                  {val.acl_name}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                    </div>
                  

                    {/* Row with userType and licence dropdowns */}
                    {(isSuperAdminLogged || isCompanyUserLogged || isCallCenterAdminLogged) ? (
                                            <div className="row">
                                              
                                              {/* <Form.Group className="col-md-6 form-group">
                                                <Form.Select
                                                  id="userType"
                                                  required
                                                  value={selectedUserType}
                                                  className="p-2"
                                                  onChange={(e) => setSelectedUserType(e.target.value)}
                                                >
                                                  <option value="" disabled hidden>
                                                    UserType
                                                  </option>
                                                  {isSuperAdmin && (
                                                    <>
                                                      <option key="1" value="role_sub_superadmin">
                                                        Sub-Superadmin
                                                      </option>
                                                      <option key="2" value="role_reseller">
                                                        Reseller
                                                      </option>
                                                    </>
                                                  )}
                                                  {isCompanyAdmin && (
                                                    <>
                                                      <option key="1" value="role_cadmin">
                                                        Company User
                                                      </option>
                                                      <option key="2" value="role_ccadmin">
                                                        Call-Center
                                                      </option>
                                                    </>
                                                  )}
                                                  {isCallCenterAdmin && (
                                                    <>
                                                      <option key="1" value="role_ccadmin">
                                                        Call Centre Admin User
                                                      </option>
                                                      <option key="2" value="role_ccagent">
                                                        Call Centre Admin Agent
                                                      </option>
                                                      <option key="3" value="role_ccteamlead">
                                                        Call Centre Admin Team Lead
                                                      </option>
                                                    </>
                                                  )}
                                                </Form.Select>
                                              </Form.Group> */}

                                              {(currentEditUserRole == USER_ROLES.CALL_CENTRE_ADMIN) && (
                                                  <Form.Group className="col-md-6 form-group">
                                                    <Form.Label>Select Flow Type <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                                  <Form.Select
                                                      id="callCenterType"
                                                      required
                                                      value={selectedFlowType}
                                                      className="p-2"
                                                      onChange={(e) => setSelectedFlowType(e.target.value)}
                                                      >
                                                    <option value="" disabled hidden>
                                                      Select Flow Type
                                                    </option>
                                                    <option value="0">Asterisk</option>
                                                    {/* <option value="1">Jambonz</option> */}
                                                  </Form.Select>
                                                </Form.Group>
                                              )}

                                              {/* {companyUserRole && 
                                              <Form.Group className="col-md-6 form-group">
                                              <Form.Control
                                              type="text"
                                              id="callCenterType"
                                              required
                                              className="p-2"
                                              value={selectedFlowType == 1 ? "Jambonz" : "Asterisk"}
                                              readOnly
                                              />
                                             </Form.Group>

                                              } */}
                    
                                              {/* Licence Dropdown */}
                                              {/* {isSuperAdmin && 
                                              <Form.Group className="col-md-6 form-group">
                                                <Form.Select
                                                  id="licence"
                                                  required
                                                  value={licence}
                                                  className="p-2"
                                                  onChange={(e) => setSelectedLicence(e.target.value)}
                                                >
                                                  <option value="" disabled hidden>
                                                    Select Licence
                                                  </option>
                                                  {Array.from({ length: 10 }, (_, i) => (
                                                    <option key={(i + 1) * 10} value={(i + 1) * 10}>
                                                      {(i + 1) * 10}
                                                    </option>
                                                  ))}
                                                </Form.Select>
                                              </Form.Group>
                                              } */}
                                            </div>
                                          ) : (
                                            /* Row with only licence dropdown when userType is not rendered */
                                            <>
                                            {/* {isSuperAdmin &&
                                            <div className="row">
                                              <Form.Group className="col-md-6 form-group">
                                                <Form.Select
                                                  id="licence"
                                                  required
                                                  value={licence}
                                                  className="p-2"
                                                  onChange={(e) => setSelectedLicence(e.target.value)}
                                                >
                                                  <option value="" disabled hidden>
                                                    Select Licence
                                                  </option>
                                                  {Array.from({ length: 10 }, (_, i) => (
                                                    <option key={(i + 1) * 10} value={(i + 1) * 10}>
                                                      {(i + 1) * 10}
                                                    </option>
                                                  ))}
                                                </Form.Select>
                                              </Form.Group>
                                            </div>
                                             } */}
                                            </>
                                          )}

                                              {(loggedInUser?.id == editUserParent?.id) && (
                                                  <>
                                                      <Form.Group className="col-md-6 form-group">
                                                        <Form.Label>Select Expiry Date<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                                          <Form.Control
                                                            type="date"
                                                            min={new Date().toISOString().split("T")[0]}
                                                            max={(() => {
                                                              const maxDate = new Date();
                                                              maxDate.setFullYear(maxDate.getFullYear() + 100);
                                                              const globalMax = maxDate.toISOString().split("T")[0];

                                                              if (editUserParent?.expiry_date) {
                                                                const parentDateStr = new Date(editUserParent.expiry_date)
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                return parentDateStr < globalMax ? parentDateStr : globalMax;
                                                              }

                                                              return globalMax;
                                                            })()}
                                                            value={expiryDate}
                                                            onChange={(e) => {
                                                              const value = e.target.value;

                                                              const maxDateStr = (() => {
                                                                const maxDate = new Date();
                                                                maxDate.setFullYear(maxDate.getFullYear() + 100);
                                                                const globalMax = maxDate.toISOString().split("T")[0];

                                                                if (editUserParent?.expiry_date) {
                                                                  const parentDateStr = new Date(editUserParent.expiry_date)
                                                                    .toISOString()
                                                                    .split("T")[0];
                                                                  return parentDateStr < globalMax ? parentDateStr : globalMax;
                                                                }

                                                                return globalMax;
                                                              })();

                                                              if (value && value > maxDateStr) {
                                                                toast.error("Expiry Date cannot be greater than parent user's expiry date.");
                                                                setExpiryDate(maxDateStr);
                                                              } else {
                                                                setExpiryDate(value);
                                                              }
                                                            }}
                                                           />
                                                      </Form.Group>
                                                  </>
                                                )}
                                                {showTtsPlanId &&
                                                  <>
                                                    <Form.Group className="col-md-6 mb-3">
                                                      <Form.Label>Select TTS Plan:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                                      <Form.Select
                                                        id="tts_plan_id"
                                                        required
                                                        value={tts_plan_id}
                                                        className="p-2"
                                                        onChange={(e) => setTtsPlanId(e.target.value)}
                                                      >
                                                        <option value={""}>Select TTS Plan</option>
                                                        {ttsPlanList.map(function (val, idx) {
                                                          return (
                                                            <option key={idx} value={val.id}>
                                                              {val.plan_name}
                                                            </option>
                                                          );
                                                        })}
                                                      </Form.Select>
                                                    </Form.Group>
                                                 </>}
                                        {(selectedUserType === USER_ROLES.CALL_CENTRE_ADMIN) ? (
                                         <Form.Group className="col-md-6 form-group">
                                          <Form.Label>Select Call Center<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                         <Form.Select
                                           id="aclSetting"
                                           required
                                           value={selectedCallCenter}
                                           className="p-2"
                                           onChange={(e) => setSelectedCallCenter(e.target.value)}
                                           disabled
                                         >
                                           <option value={""}>Call Center</option>
                                           {callCenterList.map(function (val, idx) {
                                             return (
                                               <option key={idx} value={val.id}>
                                                 {val.name}
                                               </option>
                                             );
                                           })}
                                         </Form.Select>
                                       </Form.Group>
                                        ) : (
                                          <></>
                                        )}
                                  {(selectedUserType === USER_ROLES.COMPANY_ADMIN || selectedUserType === USER_ROLES.RESELLER) ? (
                                         <Form.Group className="col-md-6 form-group">
                                          <Form.Label>Select Company<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                           <Form.Select
                                             id="aclSetting"
                                             required
                                             value={selectedCompany}
                                             className="p-2"
                                             onChange={(e) => setSelectedCompany(e.target.value)}
                                             disabled
                                           >
                                             <option value={""}>Company</option>
                                             {companyList.map(function (val, idx) {
                                               return (
                                                 <option key={idx} value={val.id}>
                                                   {val.name}
                                                 </option>
                                               );
                                             })}
                                           </Form.Select>
                                         </Form.Group>
                                       ) : (
                                         <></>
                                       )}
                    
                     {/* {!isSuperAdminLogged && !(isResellerLogged && selectedUserType && selectedUserType === USER_ROLES.RESELLER) && 
                     <div className="scroll-container">

                       <Table
                        striped
                        bordered
                        hover
                        responsive
                        style={{ textAlign: "center" }}
                       >
                        <thead>
                          <tr>
                            <th style={{ width: "15%" }}>
                              Callcenter Admin Teamlead
                            </th>
                            <th style={{ width: "25%" }}>Total Agent</th>
                            <th style={{ width: "25%" }}>Live Agent</th>
                            <th style={{ width: "25%" }}>Channel</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                             <td>                            
                              <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="callcenterAdminTeamLead"
                                  placeholder="Callcenter Admin Teamlead"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence.role_ccteamlead}
                                  value={callCenterAdminTeamlead}
                                  onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccteamlead"))}
                                  required
                                  />
                                  {errors.role_ccteamlead && <small className="text-danger">{errors.role_ccteamlead}</small>}
                                </Form.Group>
                              </td>
                              <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="agent"
                                  placeholder="Agent"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence.agent}
                                  value={agent}
                                  onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
                                  required
                                  />
                                  {errors.agent && <small className="text-danger">{errors.agent}</small>}
                                </Form.Group>
                               </td>
                                <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                  <Form.Group className="form-group">
                                  <Form.Control
                                  type="number"
                                  id="agentLive"
                                  placeholder="Live Agent"
                                  maxLength={100}
                                  min={0}
                                  max={availableLicence?.live_agent}
                                  value={liveAgent}
                                  onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
                                  required
                                  />
                                  {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
                                  </Form.Group>
                                </td>
                                <td style={{ minHeight: "60px" , minWidth:"160px" }}>                        
                                  <Form.Group className="form-group">
                                    <Form.Control
                                    type="number"
                                    id="channel"
                                    placeholder="Channel"
                                    maxLength={100}
                                    min={0}
                                    max={availableLicence.channel}
                                    value={channel}
                                    onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
                                    required
                                    />
                                    {errors.channel && <small className="text-danger">{errors.channel}</small>}
                                  </Form.Group>
                                </td>
                               </tr>
                            </tbody>
                         </Table>
                    </div>

                     } */}

                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      className="mt-4"
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable}
                    >
                      Update &nbsp;
                      {buttonDisable ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default UserAdd;
